<script setup>
import { useAppNavMenuMobileState } from '@/core/composables/useAppNavMenuMobileState'

const { isOpen } = useAppNavMenuMobileState()
</script>

<template>
  <button
    class="touch-target"
    aria-label="Close menu"
    @click="isOpen = false"
  >
    <DSIcon
      class="text-secondary-300"
      icon="i-fas-xmark-large"
      size="24"
    />
  </button>
</template>
